module.exports = __webpack_public_path__ + "img/t4-purple.df705909.png";